<template>
  <div>
    <LoginPage v-on:logged-in="setAuth" v-if="!authState"></LoginPage>
    <Dashboard v-else></Dashboard>
  </div>
</template>

<script>
import LoginPage from './pages/Login'
import Dashboard from './pages/Dashboard'
import {auth} from './auth/auth.js'

export default {
  name: 'App',
  components: {
    LoginPage,
    Dashboard,
  },
  data() {
    return {
      authState: false // Reactive data property to track auth state
    }
  },
  methods: {
    setAuth(data) {
      auth.setAuth(data.token, data.expiresAt)
      // Update the reactive state to trigger re-render
      this.authState = true
      // Set default active tab for Dashboard
      try {
        localStorage.setItem('lastActiveMenu', '0')
      } catch (_) {
        // ignore storage errors
      }
    }
  },
  mounted() {
    // Check auth state on mount and set reactive property
    this.authState = auth.isAuth()
  }
}
</script>

<style lang="scss">
@import './assets/scss/main';

</style>
